export default __webpack_public_path__ + "static/media/wechatid.03caa992.jpg";